/* Unregister any previously installed service workers and clear their caches.
 * Service worker was causing stale cache issues after deployments —
 * users had to manually clear browser cache to get the new version. */

if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then(registrations => {
    for (const registration of registrations) {
      registration.unregister().then(success => {
        if (success) console.log('Service worker unregistered.')
      })
    }
  })

  if ('caches' in window) {
    caches.keys().then(names => {
      for (const name of names) {
        caches.delete(name)
      }
    })
  }
}
